import type React from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@shadeables/supabase';
import { GoogleButton } from '@shadeables/ui';
import { AuthLayout } from './AuthLayout';
import styles from './AuthLayout.module.css';

const Login: React.FC = () => {
  const { login, signInWithGoogle } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      await login({ email, password });
    } catch (err) {
      setError((err as Error).message);
    }
  };

  return (
    <AuthLayout title="Login">
      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.inputGroup}>
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className={styles.input}
          />
        </div>
        <div className={styles.inputGroup}>
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className={styles.input}
          />
        </div>
        {error && <p className={styles.error}>{error}</p>}
        <button type="submit" className={styles.button}>
          Login
        </button>
      </form>
      <div className={styles.divider} />
      <GoogleButton onClick={signInWithGoogle} variant="signin" />
      <div className={styles.authLink}>
        Don't have an account? <Link to="/signup">Sign up</Link>
      </div>
    </AuthLayout>
  );
};

export default Login;
